import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames/bind';
import Link from 'components/shared/link';
import SubMenu from 'components/shared/sub-menu';
import useMenu from './use-menu';

import SubMenuSections from './sub-menu-sections';

import styles from './menu.module.scss';

const cx = classNames.bind(styles);

const Menu = ({ className, theme, items }) => {
  const { menuItems, dropdownArrowRef, activeLabel, handleNavBlur, handleLabelSelected } = useMenu(
    items,
    styles
  );
  return (
    <>
      <nav className={cx('wrapper', theme, className)} onMouseLeave={handleNavBlur}>
        <ul className={cx('list')}>
          {menuItems.map((menuItem, index) => {
            const itemLabel =
              menuItem.childItems.nodes.length > 0 ? menuItem.label.toLowerCase() : '';

            return (
              <li
                className={cx('item')}
                data-label={itemLabel}
                onMouseOver={handleLabelSelected}
                onFocus={handleLabelSelected}
                key={index}
              >
                <Link className={cx('link')} to={menuItem.path}>
                  {menuItem.label}
                </Link>
              </li>
            );
          })}
        </ul>

        <span className={cx('dropdown-arrow')} aria-hidden hidden ref={dropdownArrowRef} />

        {menuItems.map((menuItem, index) => {
          const dropdownLabel = menuItem.label.toLowerCase();
          const hasSubMenuSections = menuItem.childItems.nodes.every(
            ({ childItems }) => childItems.nodes.length
          );

          return (
            <React.Fragment key={index}>
              {menuItem.childItems.nodes.length > 0 && (
                <div
                  className={cx(
                    'dropdown',
                    { 'dropdown-sections': hasSubMenuSections },
                    { dropdownActive: dropdownLabel === activeLabel }
                  )}
                  data-label={dropdownLabel}
                  data-columns={hasSubMenuSections ? menuItem.childItems.nodes.length : null}
                  aria-hidden={dropdownLabel !== activeLabel}
                >
                  {hasSubMenuSections ? (
                    <SubMenuSections items={menuItem.childItems.nodes} />
                  ) : (
                    <SubMenu items={menuItem.childItems.nodes} />
                  )}
                </div>
              )}
            </React.Fragment>
          );
        })}
      </nav>
    </>
  );
};

Menu.propTypes = {
  className: PropTypes.string,
  theme: PropTypes.oneOf(['primary', 'secondary']),
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      childItems: PropTypes.shape({
        nodes: PropTypes.arrayOf(
          PropTypes.shape({
            label: PropTypes.string.isRequired,
            path: PropTypes.string.isRequired,
            description: PropTypes.string,
            acf: PropTypes.shape({
              iconName: PropTypes.string,
            }),
            childItems: PropTypes.shape({
              nodes: PropTypes.arrayOf(
                PropTypes.shape({
                  label: PropTypes.string.isRequired,
                  path: PropTypes.string.isRequired,
                  description: PropTypes.string,
                  acf: PropTypes.shape({
                    iconName: PropTypes.string,
                  }),
                })
              ),
            }),
          })
        ),
      }),
    })
  ).isRequired,
};

Menu.defaultProps = {
  className: null,
  theme: 'primary',
};

export default Menu;
